import { Signal, Fingerprint, SignalNode } from '../../../../../types';
import { WorkflowNodeProps } from '../..';

import NodeContainer from '../../Container';
import CategorySection from '../../CategorySection';
import {
  BlockFingerprintEditor,
  FingerprintList,
} from '@/components/SignalEditor';
import { blockAttributes } from '@/components/SignalEditor/BlockFingerprintEditor';

// Main BlockNode Component
export function BlockNode({
  id,
  data,
  onChange: handleSave,
}: WorkflowNodeProps<SignalNode>) {
  const signal = data.signal;

  // Function called by CreateFingerprint when a new one is saved
  const handleAddFingerprint = (newFingerprint: Fingerprint) => {
    const updatedSignal = {
      ...signal,
      fingerprints: [...signal.fingerprints, newFingerprint],
    };
    handleSave(id, { signal: updatedSignal as Signal });
  };

  // Function called when editing an existing fingerprint
  const handleEditFingerprint = (
    index: number,
    updatedFingerprint: Fingerprint,
  ) => {
    const updatedFingerprints = [...signal.fingerprints];
    updatedFingerprints[index] = updatedFingerprint;

    const updatedSignal = {
      ...signal,
      fingerprints: updatedFingerprints,
    };
    handleSave(id, { signal: updatedSignal as Signal });
  };

  // Function called when deleting a fingerprint
  const handleDeleteFingerprint = (index: number) => {
    const updatedFingerprints = signal.fingerprints.filter(
      (_: Fingerprint, i: number) => i !== index,
    );

    const updatedSignal: Signal = {
      ...signal,
      fingerprints: updatedFingerprints,
    };
    handleSave(id, { signal: updatedSignal });
  };

  return (
    <NodeContainer
      title={signal.name}
      data={data}
      signalType={signal.signalType}
      nodeId={id}
    >
      <CategorySection title="Conditions" count={signal.fingerprints.length}>
        <FingerprintList
          fingerprints={signal.fingerprints}
          signalType={signal.signalType}
          onAdd={handleAddFingerprint}
          onEdit={handleEditFingerprint}
          onDelete={handleDeleteFingerprint}
        />
      </CategorySection>
    </NodeContainer>
  );
}

export default BlockNode;

// Re-export for backward compatibility
export { BlockFingerprintEditor, blockAttributes };
